export const FGTN_SETUP_SQL = `-- FGTN (Fishing Gear & Tech News) weekly episode pages
-- Public read of published episodes; only signed-in users can write.

CREATE OR REPLACE FUNCTION public.set_updated_at()
RETURNS trigger
LANGUAGE plpgsql
AS $$
BEGIN
  NEW.updated_at := now();
  RETURN NEW;
END;
$$;

CREATE TABLE IF NOT EXISTS public.fgtn_episodes (
  id uuid PRIMARY KEY DEFAULT gen_random_uuid(),
  episode_number integer NOT NULL,
  title text NOT NULL,
  air_date date NOT NULL,
  body_html text NOT NULL DEFAULT '',
  published boolean NOT NULL DEFAULT true,
  created_at timestamptz NOT NULL DEFAULT now(),
  updated_at timestamptz NOT NULL DEFAULT now(),
  CONSTRAINT fgtn_episodes_episode_number_positive CHECK (episode_number > 0),
  CONSTRAINT fgtn_episodes_episode_number_unique UNIQUE (episode_number)
);

CREATE INDEX IF NOT EXISTS fgtn_episodes_air_date_idx
  ON public.fgtn_episodes (air_date DESC);

CREATE INDEX IF NOT EXISTS fgtn_episodes_published_number_idx
  ON public.fgtn_episodes (published, episode_number DESC);

COMMENT ON TABLE public.fgtn_episodes IS
  'Weekly Fishing Gear & Tech News show pages; public URL is /fgtn/{episode_number}.';

DROP TRIGGER IF EXISTS fgtn_episodes_set_updated_at ON public.fgtn_episodes;
CREATE TRIGGER fgtn_episodes_set_updated_at
  BEFORE UPDATE ON public.fgtn_episodes
  FOR EACH ROW
  EXECUTE FUNCTION public.set_updated_at();

ALTER TABLE public.fgtn_episodes ENABLE ROW LEVEL SECURITY;

DROP POLICY IF EXISTS "Public read published fgtn episodes" ON public.fgtn_episodes;
CREATE POLICY "Public read published fgtn episodes"
  ON public.fgtn_episodes
  FOR SELECT
  TO anon, authenticated
  USING (published = true);

DROP POLICY IF EXISTS "Authenticated read all fgtn episodes" ON public.fgtn_episodes;
CREATE POLICY "Authenticated read all fgtn episodes"
  ON public.fgtn_episodes
  FOR SELECT
  TO authenticated
  USING (true);

DROP POLICY IF EXISTS "Authenticated insert fgtn episodes" ON public.fgtn_episodes;
CREATE POLICY "Authenticated insert fgtn episodes"
  ON public.fgtn_episodes
  FOR INSERT
  TO authenticated
  WITH CHECK (true);

DROP POLICY IF EXISTS "Authenticated update fgtn episodes" ON public.fgtn_episodes;
CREATE POLICY "Authenticated update fgtn episodes"
  ON public.fgtn_episodes
  FOR UPDATE
  TO authenticated
  USING (true)
  WITH CHECK (true);

DROP POLICY IF EXISTS "Authenticated delete fgtn episodes" ON public.fgtn_episodes;
CREATE POLICY "Authenticated delete fgtn episodes"
  ON public.fgtn_episodes
  FOR DELETE
  TO authenticated
  USING (true);

GRANT SELECT ON public.fgtn_episodes TO anon, authenticated;
GRANT INSERT, UPDATE, DELETE ON public.fgtn_episodes TO authenticated;
`;
